import React, { useState, useRef } from 'react';
import { useOutsideClick, sendTrackingInfo } from '@panel/commons';
import moment from 'moment';
import { momentFormaterISO } from '@panel/commons/helpers';
import Radio from '@panel/commons/lib/Input/InputRadio';
import { isBrasilSite } from '@panel/commons/helpers/siteUtils';
import { useTranslation } from 'react-i18next';
import CustomHeader from '../DatePicker/CustomHeader';
import DatePicker from '../DatePicker';
import { formatDatePicker } from '../../helpers/datesFormatHelper';
import {
  ContainerDropdown,
  CollapsedDropdown,
  ElementBox,
  Icon,
  TextSelected,
  PlaceHolderStyled,
  Chevron,
  OpenDropdown,
  ListItems,
  ContainerDatePicker,
  ButtonContainer,
  CTA
} from './styles';

const Dropdown = ({
  width,
  height,
  selectOptions,
  icon,
  placeHolder,
  currentFilter,
  startFilter,
  endFilter,
  callback,
  isDesktop,
  device,
  disabled,
  insideHeader,
  isStatisticsByPosting,
  currentTab
}) => {
  const { t } = useTranslation();
  const [dropDownState, setDropDownState] = useState(false);
  const [filterSelected, setFilterSelected] = useState(currentFilter);
  const [startDateFrom, setStartDateFrom] = useState();
  const [startDateTo, setStartDateTo] = useState();
  const [activeStart, setActiveStart] = useState(false);
  const [activeEnd, setActiveEnd] = useState(false);
  const isDisabled = (selectOptions && selectOptions.length === 0) || (!selectOptions && !placeHolder) || disabled;
  const listRef = useRef(null);

  const onClose = () => {
    setFilterSelected(currentFilter);
    setStartDateFrom(startFilter ? formatDatePicker(startFilter) : '');
    setStartDateTo(endFilter ? formatDatePicker(endFilter) : '');
    if (dropDownState) {
      setDropDownState(false);
    }
  };
  useOutsideClick(listRef, onClose);

  const minDate = new Date('04/01/2022');
  let currentYear = minDate.getFullYear();
  const years = (() => {
    const yearss = [];
    while (currentYear <= new Date().getFullYear()) {
      yearss.push({ label: currentYear, value: currentYear });
      currentYear += 1;
    }
    return yearss;
  })(currentYear);

  const header = CustomHeader(
    years,
    moment.months().map(d => {
      return { label: d, value: d };
    })
  );

  const handleOnChangeFrom = (date, e) => {
    e.stopPropagation();
    setStartDateFrom(date);
  };

  const handleOnChangeTo = (date, e) => {
    e.stopPropagation();
    setStartDateTo(date);
  };

  return (
    <ContainerDropdown width={width} data-panel='panel-estadisticas-dropdownContainer'>
      <CollapsedDropdown
        width={!isDesktop ? '100%' : 'fit-content'}
        height={height || '34px'}
        device={device}
        active={dropDownState}
        placeHolder={placeHolder}
        disabled={isDisabled}
        onClick={e => {
          e.stopPropagation();
          if (isDisabled) {
            return () => {};
          }
          return setDropDownState(!dropDownState);
        }}
        withoutBorder={disabled}
        insideHeader={insideHeader}
        isStatisticsByPosting={isStatisticsByPosting}
      >
        <ElementBox insideHeader={insideHeader}>
          {icon && <Icon src={icon} data-panel='panel-estadisticas-dropdownIcon' disabled={isDisabled} />}
          {(currentFilter && currentTab === 'performance' && !isDisabled) || isStatisticsByPosting ? (
            <TextSelected data-panel={`panel-estadisticas-dropdown-${currentFilter}`}>
              {currentFilter !== 'customPeriod'
                ? t(`panel.estadisticas.dropdown.${currentFilter}`)
                : `${startFilter} - ${endFilter}`}
            </TextSelected>
          ) : (
            <PlaceHolderStyled data-panel={`panel-estadisticas-dropdownPlaceH-${placeHolder}`}>
              {placeHolder}
            </PlaceHolderStyled>
          )}
        </ElementBox>
        <Chevron
          active={dropDownState}
          data-panel='panel-estadisticas-dropdownChevron'
          disabled={isDisabled}
          insideHeader={insideHeader}
        />
      </CollapsedDropdown>
      <OpenDropdown width={width} active={dropDownState} ref={listRef} insideHeader={insideHeader}>
        {selectOptions &&
          Object.keys(selectOptions).map(option => {
            return (
              <ListItems
                key={option}
                data-panel={`panel-estadisticas-dropdownSelect-${option}`}
                onClick={() => {
                  setFilterSelected(option);
                  if (option === 'customPeriod' && !startDateFrom) {
                    document.getElementById('input-from').click();
                  }
                }}
              >
                <label htmlFor={`radio-filter-${option}`}>
                  <Radio
                    name={`radio-filter-${option}`}
                    checked={filterSelected === option}
                    onChange={e => {
                      e.stopPropagation();
                      setFilterSelected(option);
                      if (option === 'customPeriod' && !startDateFrom) {
                        document.getElementById('input-from').click();
                      }
                    }}
                    marginRight='8'
                    marginBottom='3'
                  />
                  <div>{t(`panel.estadisticas.dropdown.${option}`)}</div>
                </label>
              </ListItems>
            );
          })}
        <ContainerDatePicker device={device}>
          <DatePicker
            onChangeFrom={handleOnChangeFrom}
            onChangeTo={handleOnChangeTo}
            startDate={startDateFrom}
            endDate={startDateTo}
            minDate={minDate}
            maxDate={new Date()}
            locale={isBrasilSite ? 'pt' : 'es'}
            customHeader={header}
            handleCalendarOpenFrom={() => {
              setFilterSelected('customPeriod');
              if (!startDateFrom) {
                setStartDateFrom(startDateTo);
              }
              setActiveStart(true);
            }}
            handleCalendarCloseFrom={() => {
              if (!startDateTo) {
                setStartDateTo(startDateFrom);
              }
              if (filterSelected === 'customPeriod' && activeStart && startDateFrom && !startDateTo) {
                document.getElementById('input-to').click();
              }
              setActiveStart(false);
            }}
            handleCalendarOpenTo={() => {
              setFilterSelected('customPeriod');
              setActiveEnd(true);
            }}
            handleCalendarCloseTo={() => {
              if (activeEnd && startDateTo && !startDateFrom) {
                document.getElementById('input-from').click();
              }
              setActiveEnd(false);
            }}
            activeStart={activeStart}
            activeEnd={activeEnd}
            isStatisticsByPosting={isStatisticsByPosting}
          />
        </ContainerDatePicker>
        <ButtonContainer>
          <CTA
            onClick={() => {
              if (filterSelected !== 'customPeriod') {
                callback(filterSelected);
                if (filterSelected !== 'customPeriod' && (startDateFrom || startDateTo)) {
                  setStartDateFrom('');
                  setStartDateTo('');
                }
              }
              if (filterSelected === 'customPeriod' && startDateFrom !== '' && startDateTo !== '') {
                callback(
                  filterSelected,
                  momentFormaterISO(startDateFrom, 'DD/MM/YYYY'),
                  momentFormaterISO(startDateTo, 'DD/MM/YYYY')
                );
              }
              sendTrackingInfo(
                'Panel',
                'Estadisticas',
                `Rendimiento-Filtro-Fecha-${t(`panel.estadisticas.dropdown.${filterSelected}`)}`
              );
              setDropDownState(!dropDownState);
            }}
            data-panel='panel-estadisticas-filtro-buttonCTA'
          >
            Aplicar
          </CTA>
        </ButtonContainer>
      </OpenDropdown>
    </ContainerDropdown>
  );
};

export default Dropdown;
